import * as XLSX from "xlsx";
import {
  deviceHasIpOnRecord,
  formatNullableBoolean,
  formatOptionalPayloadCacheColumnValue,
  isDeviceInKiosk,
  readDeviceIsPlugged,
  readDevicePayloadField,
} from "./mdmDeviceDisplayUtils";

export const exportCurrentViewToExcel = ({
  displayedDevices,
  activeManagedColumnKeys,
  isAllDevicesView,
  activeOptionalTimeColumns,
  activeOptionalPayloadCacheColumns,
  deviceActionResults,
  formatTime,
  cleanSsid,
  getStatus,
  getDuplicateFolderPath,
  getCurrentFolderName,
}) => {
  const rows = displayedDevices.map((device) => {
    const row = {
      "Device Name": device?.deviceId || "No Data",
    };

    if (activeManagedColumnKeys.includes("agentCheckIn")) {
      row["Agent Check-in"] = formatTime(device?.deviceInfo?.timestamp);
    }
    if (activeManagedColumnKeys.includes("battery")) {
      row.Battery = Number.isFinite(Number(device?.deviceInfo?.batteryLevel))
        ? `${device.deviceInfo.batteryLevel}%`
        : "No Data";
    }
    if (activeManagedColumnKeys.includes("chargingStatus")) {
      row.Charging = formatNullableBoolean(readDeviceIsPlugged(device));
    }
    if (activeManagedColumnKeys.includes("networkSsid")) {
      row["Network SSID"] = cleanSsid(device?.deviceInfo?.SSID);
    }
    if (activeManagedColumnKeys.includes("hasIp")) {
      row.IP = deviceHasIpOnRecord(device) ? "True" : "False";
    }
    if (isAllDevicesView && activeManagedColumnKeys.includes("folderPath")) {
      row["Folder Path"] = getDuplicateFolderPath(device?.deviceId) || "-";
    }
    if (activeManagedColumnKeys.includes("currentFolder")) {
      row["Current Folder"] = getCurrentFolderName(device?.deviceId) || "-";
    }
    if (activeManagedColumnKeys.includes("notes")) {
      const notesValue = readDevicePayloadField(device, ["notes"]);
      row.Notes = notesValue == null || notesValue === "" ? "No Data" : String(notesValue);
    }

    activeOptionalTimeColumns.forEach((column) => {
      row[column.label] = formatTime(
        deviceActionResults?.[device?.deviceId]?.[column.actionKey]?.updated_at
      );
    });

    activeOptionalPayloadCacheColumns.forEach((column) => {
      row[column.label] = formatOptionalPayloadCacheColumnValue(device, column);
    });

    if (activeManagedColumnKeys.includes("inKiosk")) {
      row["In Kiosk"] = isDeviceInKiosk(device) ? "True" : "False";
    }

    if (activeManagedColumnKeys.includes("status")) {
      row.Status = getStatus(device?.isConnected).label;
    }
    return row;
  });

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Devices");
  const timeLabel = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
  XLSX.writeFile(workbook, `mdm-devices-current-view-${timeLabel}.xlsx`);
};
